<template>
    <v-dialog v-model="show" :width="width">
        <v-card>
            <v-toolbar align="center" flat dense>
                <v-spacer/>
                <v-card-subtitle style="font-size: 16px;font-weight: bold">{{title}}</v-card-subtitle>
                <v-spacer/>
                <v-btn small icon>
                    <v-icon small @click="show=false">mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider/>
            <v-card-text class="mt-4">
                <v-row class="d-flex flex-sm-column flex-md-row" no-gutters v-for="(item,index) in formRows"
                       :key="index">
                    <v-col :cols="12/column" v-for="(colItem,colIndex) in item" :key="colIndex">
                        <v-form-field v-if="colItem.type=='text'" :label-width="labelWidth" :field-width="fieldWidth"
                                      :label="colItem.name"
                                      v-model="colItem.value"/>
                        <v-form-selector v-if="colItem.type=='select'" :items="selectorItems[colItem.code]"
                                         :label-width="labelWidth"
                                         :field-width="fieldWidth" :label="colItem.name"
                                         v-model="colItem.value">
                        </v-form-selector>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn tile color="primary" @click="onOk">{{okTitle}}</v-btn>
                <v-btn tile outlined @click="show=false">{{cancelTitle}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import _ from 'lodash';

    export default {
        name: "FormDialog",
        props: {
            title: {
                type: String
            },
            value: {
                type: Boolean,
                default: false
            },
            fieldExp: {
                type: String,
                default: '名称|name,表达式|exp,名称|name,表达式|exp,名称|name,表达式|exp'
            },
            fields: {
                type: Array
            },
            labelWidth: {
                type: Number,
                default: 75
            },
            fieldWidth: {
                type: Number,
                default: 200
            },
            width: {
                type: Number,
                default: 600
            },
            item: {},
            column: {
                type: Number,
                default: 1
            },
            selectValueExp: {
                type: String
            },
            okTitle: {
                type: String,
                default: '确定'
            },
            cancelTitle: {
                type: String,
                default: '取消'
            },
            saveContinue: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value(val) {
                this.show = this.value;
            },
            show(val) {
                this.$emit('input', val);
            }
        },
        created() {
            this.show = this.value;
            this.dataItem = this.item ? _.cloneDeep(this.item) : Object.create(null);
            this.parseExpression(this.fieldExp);
        },
        data() {
            return {
                show: null,
                dataItem: {},
                formFields: [],
                formRows: [],
                selectorItems: {}
            }
        },
        methods: {
            parseExpression(exp) {
                if (exp) {
                    let exps = exp.split(",");
                    exps.forEach(item => {
                        let ss = item.split("|");
                        let code = ss.length > 1 ? ss[1] : ss[0];
                        this.formFields.push({
                            name: ss[0],
                            code: ss.length > 1 ? ss[1] : ss[0],
                            type: ss.length > 2 ? ss[2] : 'text',
                            value: this.dataItem[code]
                        })
                    })
                }
                if (this.selectValueExp) {
                    let exps = this.selectValueExp.split("-");
                    exps.forEach(item => {
                        let ss = item.split(":");
                        let code = ss[0];
                        this.selectorItems[code] = ss[1];
                    })
                }
                let count = 0;
                for (let i = 0; i < this.formFields.length; i = i + this.column) {
                    let row = [];
                    for (let j = 0; j < this.column && (i + j) < this.formFields.length; ++j) {
                        ++count;
                        row.push(this.formFields[i + j]);
                    }
                    this.formRows.push(row);
                }
            },
            onOk() {
                this.formFields.forEach(x => {
                    this.dataItem[x.code] = x.value;
                    if (this.saveContinue) {
                        x.value = null;
                    }
                })
                this.$emit('ok', this.dataItem);
            },
            onCancel(){
                this.show = false;
                this.$emit('cancel', this.dataItem);
            }
        }
    }
</script>
